import React, { createRef, useState, useRef, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "../../../assets/css/filePond.css";
import "../../../assets/css/flexibleModalLegacy.css";
import { API_BASE, STUDENT_FILE_DOWNLOAD, IMAGE_URL, downloadURL, TABLE_DATE_TIME_FORMAT } from "../../../utils/Constants";
import { getToken } from "../../../utils/Auth";
import { getFormattedTime, InitialRender } from "../../common/Helper";
import { TrimText } from "../../common/TrimText";
import { RenderTicketLinksMemoized } from "../../../utils/renderTicketLinks";
import Hover from "../../common/Hover";
import { checkIfImageExists, convertToLocalTime } from "../../../utils/commonFunction";
import axios from "axios";
import {
  LinkPopover,
  LinkPopoverContent,
  LinkFieldName,
  LinkFieldUrl,
  LinkLabel,
  LinkInputBox,
  InsertButton,
  PopoverCloseButton,
} from "./ViewTicketBlock.styles";

const Comments = (props) => {
  const { ticketData, ticketThread } = props;
  const filePondRef = createRef();
  const btnAttachment = createRef();
  const scroll_down_bottom = useRef();
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [showFilePond, setShowFilePond] = useState(false);
  const [removeFile, setRemoveFile] = useState(null);
  const [InputMessage, setInputMessage] = useState("");
  const [fileIdMap, setFileIdMap] = useState({});
  const pendingUploadId = useRef(null);

  const [currentimage, setcurrentimage] = useState("");

  const [showLinkFields, setShowLinkFields] = useState(false);
  const [linkName, setLinkName] = useState("");
  const [linkUrl, setLinkUrl] = useState("");

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setShowLinkFields(false);
      }
    };

    if (showLinkFields) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [showLinkFields]);

  const handleInputChange = (e) => {
    setInputMessage(e.target.value);
  };

  /**
 * Triggers the hidden file input to open the file picker dialog.
 *
 * @returns {void} Resets the input value and programmatically clicks the file input.
 */

  const handleAttachment = () => {
    if (btnAttachment.current) {
      btnAttachment.current.value = '';
    }

    btnAttachment.current.click();
  };

  const handleDragEnter = (event) => {
    setShowFilePond(true);
  };

  /**
 * Handles uploaded file responses and updates the attachments list.
 *
 * @param {string} response - The uploaded file response or file name.
 * @returns {void} Adds the uploaded file (with or without pending upload ID) to attachments.
 */
  const handleUploadedFiles = (response) => {
     if (pendingUploadId.current) {
      const attachmentWithId = `${response}@@${pendingUploadId.current}`;
      setAttachments((attachments) => [...attachments, attachmentWithId]);
      pendingUploadId.current = null;
    } else {
      setAttachments((attachments) => [...attachments, response]);
    }
  };

  /**
 * Handles file input change and adds the selected file to FilePond.
 *
 * @param {React.ChangeEvent<HTMLInputElement>} event - File input change event.
 * @returns {Promise<void>} Adds the selected file to FilePond or logs an error if it fails.
 */
  const handleFiles = async (event) => {
    const ufiles = await event.target.files;
    if (ufiles.length > 0) {
      if (ufiles[0]) {
      if (filePondRef.current) {
        filePondRef.current
          .addFile(ufiles[0])
          .then((file) => {
          })
          .catch((error) => console.error(error));
      }
    }
    }
  };

  const handleFilePondInit = () => { };

  const handleSendMessage = useCallback(() => {
    const cleanAttachments = attachments.map(att => att.split('@@')[0]);

    let messagepost = {
      message: InputMessage,
      files: cleanAttachments,
      // taggedUsers,
      id_ticket: props.ticketData.id_ticket,
    };

    props.handleTicketThreadList(messagepost);

    setInputMessage("");
    setFiles([]);
    setAttachments([]);
    setFileIdMap({});
    setShowFilePond(false);
  }, [InputMessage, attachments, props.ticketData.id_ticket, props.handleTicketThreadList]);

  const downloadAs = (url, name) => {
    axios.get(url, {
      responseType: "blob"
    })
      .then(response => {
        const a = document.createElement("a");
        const url = window.URL.createObjectURL(response.data);
        a.href = url;
        a.download = name;
        a.click();
      })
      .catch(err => {
        console.error("error", err);
      });
  };

  const downloadFile = async (absolutePath, fileName, index) => {
    const url = downloadURL + (!absolutePath.includes("http") ? STUDENT_FILE_DOWNLOAD + "/" : "") +
      absolutePath.replace("/home/myaie/public_html/", "").replace("public/", "").replace(/(^\w+:|^)\/\//, '');
    downloadAs(url, fileName);
  };

  function autosize(e) {
    const el = e.target;
    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
  }

  const insertCommentLink = () => {
    const name = linkName.trim();
    const url = linkUrl.trim();

    if (!name || !url) {
      return;
    }

    if (!/^(https?:\/\/|mailto:)/i.test(url)) {
      return;
    }

    const spacing = InputMessage && !InputMessage.endsWith(" ") ? " " : "";

    setInputMessage(
      `${InputMessage}${spacing}[${name}](${url})`
    );

    setLinkName("");
    setLinkUrl("");
    setShowLinkFields(false);
  };

  return (
    <div className="comment-main ac-white-card p-0">
      <div className="comments-card-body">
        <div className="comment-conversation-list-wrap">
          <div className="">
            <label className="card-header comments-card-header lb-black d-block">Message</label>
            <div className="card-header comments-card-sub-header pb-4 resizable text-wrap-el"> 
              {props.ticketData.campus_name && <p>Campus: {props.ticketData.campus_name} </p>}
              <RenderTicketLinksMemoized value={props.message} />
            </div>
          </div>
          <div className="card-header comments-card-header">Comments</div>
          <ul className="comment-conversation-list list-unstyled">
            {ticketThread &&
              ticketThread.length > 0 &&
              ticketThread.map((thread, index) => {
                return (
                  <React.Fragment key={index}>
                    {thread.if_sender_cms_user > 0 ? (
                      <li
                        className="comment-user-current"
                        key={thread.id_sender}
                      >
                        <div className="comment-user-bx">
                          <div className="comment-user-img comment-box-pro assigned-title-blk">
                            <div className="comment-box-pro-item">
                            <div className="assigned-title-block-new">
                            <div className="assigned-title-itm">
                              <span className="assigned-title-blk name-icon">
                                {thread.picture_me ? <><img
                                className="user-image"
                                  src={`${IMAGE_URL}/${thread.picture_me.replaceAll(
                                    "/home/myaie/public_html/",
                                    ""
                                  ).replaceAll(
                                    "public/",
                                    ""
                                  )}`}
                                  alt="AIE"
                                  onError={(e)=> {
                                    e.target.style.height = "0px"
                                    e.target.style.width = "0px"
                                  }}
                                />  </> : thread?.userFullName ? InitialRender([
                                  thread?.userFullName.split(" ")[0],
                                  thread?.userFullName.split(" ")[1],
                                ]
                                ) : InitialRender(["N", "A",])}
                                <span className={`profile-box-2-status ${thread.user_activity_status ? thread.user_activity_status.toLowerCase() == "online" ? "Online" : thread.user_activity_status.toLowerCase() == "away" ? "Away" : "Offline" : "Offline"}`}>
                                  <i className="fas fa-circle"></i>
                                </span>
                                <Hover
                                  firstName={thread?.userFullName ? thread?.userFullName.split(" ")[0] : "N"}
                                  lastName={thread?.userFullName ? thread?.userFullName.split(" ")[1] : "A"}
                                  photo={thread.picture_me}
                                  email={thread.userEmail}
                                  mobile={thread.mobile}
                                  right={false}
                                  role={"User"}
                                  status={thread?.user_status}
                                  activity_status={thread?.user_activity_status}
                                />
                              </span>
                            </div>
                            </div>
                            </div>
                          </div>

                          <div className="comment-user-detail">
                            {thread.attachments.length > 0
                              ? thread.attachments.map((file, indKey) => {
                                if (file.fileType == "download") {
                                  return (
                                    <div
                                      className="Attachment-area"
                                      key={indKey}
                                    >
                                      <i
                                        className="fa fa-paperclip"
                                        aria-hidden="true"
                                      ></i>
                                      Attached File :
                                      <a className="as-text-blue curser" onClick={()=>{downloadAs(downloadURL + (!file.attachment.includes("http") ? STUDENT_FILE_DOWNLOAD + "/" : "")+file.attachment.replace(
                                          "/home/myaie/public_html/",
                                          ""
                                        ).replace("public/","").replace(/(^\w+:|^)\/\//, ''),file.originalName)}}>{file.originalName}</a>
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div
                                      key={indKey}
                                      onClick={() =>
                                        downloadFile(
                                          file.attachment,
                                          file.originalName,
                                          1
                                        )
                                      }
                                      className="attached-media-comment Attachment-area"
                                    >
                                      <img
                                        className="curser"
                                        onClick={() => {
                                          setcurrentimage(file.attachment);
                                        }}
                                        src={(!file.attachment.includes("https://myaie.ac") ? IMAGE_URL + "/" : "") +file.attachment.replace(
                                          "/home/myaie/public_html/",
                                          ""
                                        ).replace("public/","")}
                                        alt="AIE"
                                      />
                                      <div className={`image-popup-block ${currentimage != '' ? 'active' : ''}`}>
                                        <div className="image-popup flexible-modal">
                                          <button type="button" onClick={() => { setcurrentimage('') }} className="close-icon"><i className="fas fa-times hold-show"></i></button>
                                          <div className="image-popup-img">
                                            <img src={(!currentimage.includes("https://myaie.ac") ? IMAGE_URL + "/" : "") + (currentimage.replace("/home/myaie/public_html/", "").replace("public/", "").replace("public_html", ""))} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })
                              : null}
                            {thread.message && thread.message !== "" ? (
                              <div className="posted-comment">
                                <RenderTicketLinksMemoized value={thread.message} />
                              </div>
                            ) : null}
                            <small className="date">
                              {" "}
                              {convertToLocalTime(thread.send_date, TABLE_DATE_TIME_FORMAT)}
                            </small>
                          </div>
                        </div>
                      </li>
                    ) : (
                      <li className="comment-user-other" key={thread.id_sender}>
                        <div className="comment-user-bx">
                          <div className="comment-user-img comment-box-pro assigned-title-blk">
                            <div className="comment-box-pro-item">
                            <div className="assigned-title-block-new">
                            <div className="assigned-title-itm">
                              <span className="assigned-title-blk  name-icon">
                                {thread.picture_me ? (
                                  <img
                                  className="user-image"
                                  src={`${IMAGE_URL}/${thread.picture_me.replaceAll(
                                    "/home/myaie/public_html/",
                                    ""
                                  ).replace("public/", "")}`}
                                  alt="AIE"
                                />
                                ) : thread?.userFullName ? InitialRender([
                                  thread?.userFullName.split(" ")[0],
                                  thread?.userFullName.split(" ")[1],
                                ]) : InitialRender(["N", "A",])}
                              <span className={`profile-box-2-status ${thread.student_activity_status ? thread.student_activity_status.toLowerCase() == "online" ? "Online" : thread.student_activity_status.toLowerCase() == "away" ? "Away" : "Offline" : "Offline"}`}>
                                <i className="fas fa-circle"></i>
                              </span>
                              <Hover
                              firstName={thread?.userFullName ? thread?.userFullName.split(" ")[0] : "N"}
                              lastName={thread?.userFullName ? thread?.userFullName.split(" ")[1] : "A"}
                              photo={thread.picture_me}
                              email={thread.userEmail}
                              mobile={thread.mobile}
                              right={false}
                              role={"User"}
                              status={thread.student_status} 
                              activity_status={thread.student_activity_status} 
                              showNumber={true} 
                              number={thread.student_crm_id}
                            />
                              </span>
                            </div>
                            </div>
                            </div>
                          </div>

                          <div className="comment-user-detail bg-transparent">
                            <div className="mb-1">{thread?.userFullName}</div>
                            {thread.attachments.length > 0
                              ? thread.attachments.map((file, ind) => {
                                if (file.fileType == "download") {
                                  return (
                                    <div
                                      className="Attachment-area"
                                      key={ind}
                                    >
                                      <i
                                        className="fa fa-paperclip"
                                        aria-hidden="true"
                                      ></i>
                                      Attached File :
                                      <a className="as-text-blue curser" onClick={()=>{downloadAs(downloadURL + (!file.attachment.includes("http") ? STUDENT_FILE_DOWNLOAD + "/" : "")+file.attachment.replace(
                                          "/home/myaie/public_html/",
                                          ""
                                        ).replace("public/","").replace(/(^\w+:|^)\/\//, ''),file.originalName)}}>{file.originalName}</a>
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div
                                      key={ind}
                                      onClick={() =>
                                        downloadFile(
                                          file.attachment,
                                          file.originalName,
                                          1
                                        )
                                      }
                                      className="attached-media-comment Attachment-area"
                                    >
                                      <img
                                        className="curser"
                                        onClick={() => {
                                          setcurrentimage(file.attachment);
                                        }}
                                        src={file.attachment}
                                      />
                                      <div className={`image-popup-block ${currentimage != '' ? 'active' : ''}`}>
                                        <div className="image-popup flexible-modal">
                                          <button type="button" onClick={() => { setcurrentimage('') }} className="close-icon"><i className="fas fa-times hold-show"></i></button>
                                          <div className="image-popup-img">
                                            <img src={(!currentimage.includes("https://myaie.ac") ? IMAGE_URL + "/" : "") + (currentimage.replace("/home/myaie/public_html/", "").replace("public/", "").replace("public_html", ""))} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })
                              : null}
                            {thread.message && thread.message !== "" ? (
                              <div className="posted-comment">
                                {thread.read_at ? (
                                  <RenderTicketLinksMemoized value={thread.message} />
                                ) : (
                                  <b><RenderTicketLinksMemoized value={thread.message} /></b>
                                )}
                              </div>
                            ) : null}
                            <small className="date">
                              {convertToLocalTime(thread.send_date, TABLE_DATE_TIME_FORMAT)}
                            </small>
                          </div>
                        </div>
                      </li>
                    )}
                  </React.Fragment>
                );
              })}
          </ul>
        </div>
      </div>
      {ticketData && ticketData.status !== "Closed" ? (
        <>
          <div className="card-footer comments-card-footer">
            <div
              className={
                ticketData && ticketData.status == "Closed"
                  ? "comment-area-control-full"
                  : "comment-area-control"
              }
              style={{ position: "relative" }}
            >
              {showLinkFields && (
                <LinkPopover role="dialog" aria-label="Insert link">
                  <PopoverCloseButton
                    type="button"
                    title="Close"
                    aria-label="Close"
                    onClick={() => setShowLinkFields(false)}
                  >
                    <i className="fal fa-times" aria-hidden="true"></i>
                  </PopoverCloseButton>
                  <LinkPopoverContent>
                    <LinkFieldName>
                      <LinkLabel htmlFor="commentLinkName">Link</LinkLabel>
                      <LinkInputBox>
                        <input
                          id="commentLinkName"
                          type="text"
                          placeholder="Link Text"
                          value={linkName}
                          onChange={(e) => setLinkName(e.target.value)}
                        />
                      </LinkInputBox>
                    </LinkFieldName>
                    <LinkFieldUrl>
                      <LinkLabel htmlFor="commentLinkUrl">URL</LinkLabel>
                      <LinkInputBox>
                        <input
                          id="commentLinkUrl"
                          type="url"
                          placeholder="https://"
                          value={linkUrl}
                          onChange={(e) => setLinkUrl(e.target.value)}
                        />
                      </LinkInputBox>
                    </LinkFieldUrl>
                    <InsertButton
                      type="button"
                      onClick={insertCommentLink}
                    >
                      <i className="fal fa-plus" aria-hidden="true"></i>
                      <span>Insert</span>
                    </InsertButton>
                  </LinkPopoverContent>
                </LinkPopover>
              )}
              <textarea style={{ cursor: props.cursorLoading ? "wait" : "default" }}
                className="form-control comment-form-control ticket-message"
                placeholder="Start typing..."
                onChange={handleInputChange}
                onKeyDown={autosize}
                // rows={1}
                value={InputMessage}
                onDragEnter={handleDragEnter}
                // onDragLeave={handleDragExit}
                disabled={
                  ticketData && ticketData.status == "Closed" ? true : false
                }
              />
            </div>
            <div className="comment-area-actions">
              <button
              style={{ cursor: props.cursorLoading ? "wait" : "default" }} 
                type="button"
                title="Add Attachment"
                className="btn btn-submit-arrow no-shadow"
                disabled={
                  ticketData && ticketData.status == "Closed" ? true : false
                }
                onClick={handleAttachment}
              >
                <i className="fal fa-paperclip"></i>
              </button>
              <div>
                <input
                  style={{ cursor: props.cursorLoading ? "wait" : "default" , display: "none" }} 
                  disabled={
                    ticketData && ticketData.status == "Closed" ? true : false
                  }
                  type="file"
                  ref={btnAttachment}
                  // style={{ display: "none" }}
                  onChange={(e) => handleFiles(e)}
                  showalerts={"false"}
                />
              </div>
              <button
                style={{ cursor: props.cursorLoading ? "wait" : "default" }}
                type="button"
                title="Add Hyperlink"
                className="btn btn-submit-arrow no-shadow"
                onClick={() => setShowLinkFields(!showLinkFields)}
                disabled={ticketData && ticketData.status == "Closed" ? true : false}
              >
                <i className="fal fa-link"></i>
              </button>
              {!InputMessage && !files.length ? (
                <button
                style={{ cursor: props.cursorLoading ? "wait" : "default" }} 
                  type="button"
                  title="Send Message"
                  className="btn btn-submit-arrow no-shadow"
                  onClick={() => handleSendMessage()}
                  disabled={true}
                >
                  <i className="fal fa-paper-plane"></i>
                </button>
              ) : (
                <button
                style={{ cursor: props.cursorLoading ? "wait" : "default" }} 
                  type="button"
                  title="Send Message"
                  className="btn btn-submit-arrow no-shadow"
                  onClick={() => handleSendMessage()}
                  disabled={loading ? true : false}
                >
                  <i className="fal fa-paper-plane"></i>
                </button>
              )}
            </div>
          </div>
        </>
      ) : null}

      <div
        ref={scroll_down_bottom}
        className={!showFilePond ? "hideFilePond" : "showFilePond"}
      >
        <FilePond
          name="post"
          allowMultiple={true}
          maxFiles={3}
          ref={filePondRef}
          files={files}
          onupdatefiles={setFiles}
          /**
 * Handles cleanup before a file is removed from FilePond.
 *
 * @param {object} f - The FilePond file item being removed.
 * @returns {boolean} Always returns true to confirm file removal.
 *
 * Removes related entries from attachments and fileIdMap,
 * and sets the file name for API-based removal.
 */
          beforeRemoveFile={(f) => {
            const fileName = f.file.name;
            const uniqueId = f.getMetadata('uniqueId') || fileIdMap[fileName];
            
            if (uniqueId) {
              // Remove from attachments array
              setAttachments((prev) => 
                prev.filter((att) => !att.includes(`@@${uniqueId}`))
              );
              
              // Remove from fileIdMap
              setFileIdMap((prev) => {
                const newMap = { ...prev };
                delete newMap[fileName];
                return newMap;
              });
              
              // Extract original filename from attachment for removal API
              const attachmentToRemove = attachments.find((att) => att.includes(`@@${uniqueId}`));
              if (attachmentToRemove) {
                const originalPath = attachmentToRemove.split('@@')[0];
                const fileNameFromPath = originalPath.split('/').pop();
                setRemoveFile(fileNameFromPath);
              }
            } else {
              setRemoveFile(fileName);
            }
            
            return true;
          }}
          init={handleFilePondInit}
          onaddfile={(err, fileItem) => {
            setShowFilePond(true);
            if (!err) {
              const uniqueId = `${Date.now()}_${Math.random()}`;
              const fileName = fileItem.file.name;

              // Store the unique ID in the file's metadata
              fileItem.setMetadata('uniqueId', uniqueId);

              // Update fileIdMap
              setFileIdMap((prev) => ({ ...prev, [fileName]: uniqueId }));
              
              // Store for use in onload
              pendingUploadId.current = uniqueId;
            }
          }}
          server={{
            url: API_BASE,
            process: {
              url: "/addTicketAttachment",
              headers: {
                Authorization: `Bearer ${getToken()}`,
              },
              ondata: (formData) => {
                setLoading(true);
                return formData;
              },
              onload: (response) => {
                  handleUploadedFiles(response);
                setLoading(false);
              },
            },
            revert: {
              url: `/removeFeedAttachments/fileName`,
                    headers: {
                Authorization: `Bearer ${getToken()}`,
              },
              ondata: (formData) => {
                return formData;
              },

              onload: (response) => {
                setRemoveFile(null);
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default Comments;
